import React from 'react';
import {
  PageContent,
  ContentBox,
  StatsTable
} from '../css/_styledComponents';
import { stats } from '../data/virgilJohnsonStats';

function Stats () {
  return (
    <PageContent>
      {/* <ol className="collection collection-container">
        <li className="item item-container">
          {Object.keys(stats[0]).map((key, index) => (
            <React.Fragment key={`${key}_${index.toString()}`}>
              {typeof stats[0][key] === 'object' ? (
                <div className="attribute-container">
                  {Object.keys(stats[0][key]).map((k, i) => (
                    <div key={`${k}_${i.toString()}`} className="attribute">{k}</div>
                  ))}
                </div>
              ) : (
                <div className="attribute">{key}</div>
              )}
            </React.Fragment>
          ))}
        </li>
        {stats.map((stat, idx) => (
          <li key={idx.toString()} className="item item-container">
            {Object.keys(stat).map((key, index) => (
              <React.Fragment key={`${key}_${index.toString()}`}>
                {typeof stat[key] === 'object' ? (
                  <div>
                    {Object.keys(stat[key]).map((k, i) => (
                      <div className="attribute" key={`${k}_${i.toString()}`}>{stat[key][k]}</div>
                    ))}
                  </div>
                ) : (
                  <div className="attribute">{stat[key]}</div>
                )}
              </React.Fragment>
            ))}
          </li>
        ))}
      </ol> */}
      <ContentBox type="white">
        <div style={{ overflowX: 'auto' }}>
          <StatsTable style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr style={{ color: 'white', background: '#999999' }}>
                {Object.keys(stats[0]).map((key, index) => (
                  <React.Fragment key={`${key}_${index.toString()}`}>
                    {typeof stats[0][key] === 'object' ? (
                      <td className="collection">
                        <div className="titleRow">{key}</div>
                        <div style={{ display: 'flex', alignItems: 'stretch' }}>
                          {Object.keys(stats[0][key]).map((k, i) => (
                            <div style={{ flex: '1' }} key={`${k}_${i.toString()}`}>{k}</div>
                          ))}
                        </div>
                      </td>
                    ) : (
                      <td>{key}</td>
                    )}
                  </React.Fragment>
                ))}
              </tr>
              {stats.map((stat, idx) => (
                <tr
                  key={idx.toString()}
                  {...stat.League === "NHL" && {
                    className: 'NHL'
                  }}
                >
                  {Object.keys(stat).map((key, index) => (
                    <React.Fragment key={`${key}_${index.toString()}`}>
                      {typeof stat[key] === 'object' ? (
                        <td className="collection">
                          <div style={{ display: 'flex', alignItems: 'stretch' }}>
                            {Object.keys(stat[key]).map((k, i) => (
                              <div style={{ flex: '1' }} key={`${k}_${i.toString()}`}>{stat[key][k] || '\u00A0'}</div>
                            ))}
                          </div>
                        </td>
                      ) : (
                        <td>{stat[key]}</td>
                      )}
                    </React.Fragment>
                  ))}
                </tr>
              ))}
            </tbody>
          </StatsTable>
        </div>
      </ContentBox>
    </PageContent>
  );
}

export default Stats;
